import type { PropertyMappings } from "../../../../shared/PropertyMappings.types";
import { DefaultImportTableColumns, ImportTableColumn } from "../../../../../../utilities/types";
import { columnDisplayNames } from "../../../../../admin/ImportSettings/ImportSettings.types";

/** Fields from PropertyMappings that have a corresponding ImportTableColumn */
export const PROPERTY_MAPPING_FIELDS: Set<keyof PropertyMappings> = new Set([
	"grower",
	"farm",
	"field",
	"fieldId",
	"labName",
	"labInstructions",
	"submissionNotes",
	"yieldGoal",
	"submitterName",
	"submitterEmail",
	"growerPhoneNumber",
	"eventId",
	"labSubmissionCode",
	"externalId",
	"externalFarmId",
	"externalLabId",
	"dateFieldReadyEstimated",
	"density",
	"depth",
	"frequencyOfMicros",
	"testPackage",
	"fieldPriority",
	"nextCrop",
	"lastCrop",
	"branch",
	"salesperson",
	"salespersonMobilePhone",
]);

/**
 * Primary fields shown by default (before "Show More" is clicked),
 * in the order they should appear in the UI.
 */
export const PRIMARY_PROPERTY_FIELDS_ORDERED: (keyof PropertyMappings)[] = [
	"grower",
	"farm",
	"field",
	"fieldId",
	"lastCrop",
	"nextCrop",
	"eventId",
	"labSubmissionCode",
];

/** Set version for O(1) lookups */
export const PRIMARY_PROPERTY_FIELDS: Set<keyof PropertyMappings> = new Set(PRIMARY_PROPERTY_FIELDS_ORDERED);

export interface FieldConfig {
	key: keyof PropertyMappings;
	label: string;
}

/**
 * Generate field configs in the order defined by DefaultImportTableColumns,
 * with fieldId relocated to appear immediately after field.
 */
export const FIELD_CONFIGS: FieldConfig[] = (() => {
	const configs = (Object.keys(DefaultImportTableColumns) as ImportTableColumn[])
		.filter((key) => PROPERTY_MAPPING_FIELDS.has(key as keyof PropertyMappings))
		.map((key) => ({ key: key as keyof PropertyMappings, label: columnDisplayNames[key] }));

	// Move fieldId to right after field
	const fieldIdIndex = configs.findIndex((c) => c.key === "fieldId");
	const fieldIndex = configs.findIndex((c) => c.key === "field");
	if (fieldIdIndex > -1 && fieldIndex > -1 && fieldIdIndex !== fieldIndex + 1) {
		const [fieldIdConfig] = configs.splice(fieldIdIndex, 1);
		configs.splice(fieldIndex + 1, 0, fieldIdConfig);
	}

	return configs;
})();
